module.exports = [{"name":"租售","label":"出租,出售","value":"出租,出售"},{"name":"出租","label":"出租","value":"出租"},{"name":"出售","label":"出售","value":"出售"}]


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/data/rent_sell.json
// module id = 3Nif
// module chunks = 38